<template>
  <div class="login-container">
    <div class="background"/>
    <div class="modal-wrapper">
      <div class="logo">
        <img
          src="~@/assets/five-star.svg"
          alt="Five Star">
      </div>
      <div
        class="form-modal animated"
        :class="{'animated wobble':hasError}">
        <router-view @onError="onError"/>
      </div>
      <router-link
        to="recover-password"
        class="forgot-password-link"
      >
        ¿Olvidó su contraseña?
      </router-link>
    </div>
    <div class="copyright">
      ©AGCO de México S. de R.L. Todos los derechos reservados
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginContainer',
  data () {
    return {
      hasError: false
    }
  },
  methods: {
    onError (error) {
      console.log(error)
      this.hasError = error
      setTimeout(() => {
        this.hasError = false
      }, 1500)
    }
  }
}
</script>

<style lang="scss" scoped>
  .login-container {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #efefef;
    .background {
      position: absolute;
      height: 70vh;
      width: 100%;
      top: 0;
      left: 0;
      background-image: url("/static/login-background.jpg");
      background-size: cover;
    }
    .modal-wrapper {
      z-index: 100;
    }
  }

  .logo {
    width: 100px;
    margin: 0 auto;
    img {
      max-width: 100%;
    }
  }

  .form-modal {
    width: 300px;
    margin-left: 10px;
    background-color: #ffffff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
    border-radius: 5px;
    margin-top: 20px;
    padding: 30px 50px 50px 50px;
    header {
      .logo {
        padding: 20px;
        text-align: center;
        img {
          width: 130px;
        }
      }
    }
  }

  .forgot-password-link {
    color: $color-font-primary;
    width: 400px;
    @include font-primary(12px, bold);
    text-align: center;
    display: block;
    padding: 10px;
  }

  .copyright {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 400px;
    margin-left: -200px;
    text-align: center;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding: 15px 20px;
    @include font-primary(12px, bold, normal);
    color: $color-font-primary;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login-container.vue